import React, { useState, useEffect, useRef } from 'react';
import Image from "next/image";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../../styles/Contentview.module.css';
import * as LIB from '../../lib/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFont, faBible, faShare, faLink, faHeart, faEllipsisV, faCopy } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faFacebookMessenger, faWhatsapp } from "@fortawesome/free-brands-svg-icons"
import { FacebookShareButton, WhatsappShareButton } from "react-share";
import Overlay from 'react-bootstrap/Overlay';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover';
import RelatedArticle from './relatedArticle';
import { logEvent } from '../../utils/analytics';
import Alert from 'react-bootstrap/Alert';
import Toast from 'react-bootstrap/Toast'

const ArticleHeader = ({ postData, txtFontsize, setTxtFontsize, isSmHeader }) => {
    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const [showFeatures, setShowFeatures] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const fontSizeIcon = <FontAwesomeIcon icon={faFont} />;
    const bibleIcon = <FontAwesomeIcon icon={faBible} />;
    const shareIcon = <FontAwesomeIcon icon={faShare} />;
    const likeIcon = <FontAwesomeIcon icon={faHeart} />;
    const copyIcon =  <FontAwesomeIcon icon={faCopy}/>;
    const linkIcon = <FontAwesomeIcon icon={faLink} className={styles.shareBtnIcon} />;
    const whatsappIcon = <FontAwesomeIcon icon={faWhatsapp} className={styles.shareBtnIcon} />;
    const facebookIcon = <FontAwesomeIcon icon={faFacebook} className={styles.shareBtnIcon} />;
    const facebookMsgerIcon = <FontAwesomeIcon icon={faFacebookMessenger} className={styles.shareBtnIcon} />;
    const featureIcon = <FontAwesomeIcon icon={faEllipsisV} />;

    useEffect(() => {
        if (postData) {
            // console.log('postData=', postData);
        }
        initFontSize();
    }, []);

    const handleClick = (event) => {
        setShow(!show);
        setTarget(event.target);
    };

    const initFontSize = () => {
        if (typeof window !== "undefined") {
            let checkFontSize = localStorage.getItem('fontSize');
            if (checkFontSize != null && checkFontSize != '') {
                setFontSize(checkFontSize);
            }
        }
    }
    
    const copyContentText = () => {
        let contentTxt = extractPlainText(postData.content)
        if(contentTxt){
            navigator.clipboard.writeText(contentTxt);
        }
    }

    const setFontSize = (size) => {
        if (size == 'big') {
            setTxtFontsize(30);
        } else if (size == 'middle') {
            setTxtFontsize(20);
        } else if (size == 'small') {
            setTxtFontsize(16);
        }
        //update local storage data
        localStorage.setItem('fontSize', size);
    }
    
    function extractPlainText(html) {
        // Remove text within sequences of dashes
        let cleanedText = html.replace(/－{6,}[^－]*－{6,}/g, '');

        // Use DOMParser to remove any HTML tags from the remaining text
        const parser = new DOMParser();
        const doc = parser.parseFromString(cleanedText, 'text/html');
        let textContent = doc.body.textContent || '';

        // Remove leading blank lines
        textContent = textContent.replace(/^\s*/g, '');
        
        // Regular expression to match URLs (simple version, for common cases)
        const urlPattern = /https?:\/\/[^\s]+/g;
        textContent = textContent.replace(urlPattern, '');

        return textContent;
    }


    const closeToast = () => {
        setShowToast(true);
        setTimeout(() => {
            setShowToast(false);
        }, 2000);
    }

    const renderShareOption = () => {
        const eventCategory = 'post';
        const eventAction = 'share';
        return (
            <Popover id="popover-contained" onClick={() => document.body.click()}>
                <div id='link' className={styles.shareBoxHolder} onClick={() => {
                    LIB.copyArticleLink(postData.id, postData.title)
                    closeToast()
                    logEvent(eventCategory, eventAction, postData.title, Number(postData.id))
                }}>
                    {linkIcon} 複製分享連結
                </div>
                <div className={styles.divider}></div>
                <div id='fb' className={styles.shareBoxHolder} onClick={() => logEvent(eventCategory, eventAction, postData.title, Number(postData.id))}>
                    <WhatsappShareButton
                        url={process.env.domain + `/${postData.id}`}
                        quote='錫安日報'
                    >
                        {whatsappIcon} Whatsapp 分享
                    </WhatsappShareButton>
                </div>
                <div className={styles.divider}></div>
                <div id='fb' className={styles.shareBoxHolder} onClick={() => logEvent(eventCategory, eventAction, postData.title, Number(postData.id))}>
                    <FacebookShareButton
                        url={process.env.domain + `/${postData.id}`}
                        quote='錫安日報'
                    >
                        {facebookIcon} Facebook 分享
                    </FacebookShareButton>
                </div>
            </Popover>
        )
    };

    if (postData) {
        return (
            <>
                <Toast show={showToast} className={styles.toast}>
                    <Toast.Body>已複製</Toast.Body>
                </Toast>

                <Row>
                    <Col>
                        <div className={isSmHeader === true ? `article_header_title ${styles.smTitle}` : `article_header_title ${styles.title}`}>
                            {postData.title}
                        </div>
                    </Col>
                </Row>

                <Row className={styles.headerBottom}>
                    <Col lg={6} md={6} xs={12}>
                        <div className={styles.date}>
                            <span className={`article_header_post_date`}>{postData.post_date && postData.post_date.substring(0, 10)}</span>
                            {postData.count != null && <span> | 瀏覽 : <span className={`article_header_count`}>{postData.count}</span></span>}
                            {postData.msg != null && <span> | 回應 : {postData.msg}</span>}
                            <div className={styles.featureBtn} onClick={() => { setShowFeatures(!showFeatures) }}>{featureIcon}</div>
                        </div>
                    </Col>
                    <Col lg={6} md={6} xs={12}>
                        <div className={showFeatures == false ? styles.tools : styles.hiddenTools}>
                            <div className={styles.fontsizeHelper}>
                                
                                {
                                    postData.content && <div className={styles.copyBtn} onClick={()=>{
                                        copyContentText()
                                        closeToast()
                                    }}>
                                        <span className={styles.toolTxt}>{copyIcon} 複製</span>
                                    </div>
                                }

                            
                                {
                                    postData.disable_like !== true &&
                                    <div className={`module_like_btn ${styles.likeBtn}`} >
                                        <span className={styles.toolTxt}>{likeIcon} 讚好</span>
                                    </div>
                                }

                                {
                                    postData.id && <div className={styles.shareBtn} onClick={handleClick}>
                                        <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={renderShareOption()}>
                                            <span className={styles.toolTxt}>{shareIcon} 分享</span>
                                        </OverlayTrigger>
                                    </div>
                                }

                                {
                                    postData.bible && <div className={styles.bibleBtn} onClick={() => { LIB.viewScripture(postData.bible) }}>
                                        <span className={styles.toolTxt}>{bibleIcon} 經文</span>
                                    </div>
                                }
                                <div className={styles.setFontsizeBtn}>
                                    <div className={styles.toolTxt}>{fontSizeIcon}字型 :</div>
                                    <div className={`${styles.smallFontSize} ${txtFontsize == 16 ? styles.activeFontSize : ''}`} onClick={() => { setFontSize('small') }}>小</div>
                                    <div className={styles.toolTxt}>|</div>
                                    <div className={`${styles.middleFontSize} ${txtFontsize == 20 ? styles.activeFontSize : ''}`} onClick={() => { setFontSize('middle') }}>中</div>
                                    <div className={styles.toolTxt}>|</div>
                                    <div className={`${styles.bigFontSize} ${txtFontsize == 30 ? styles.activeFontSize : ''}`} onClick={() => { setFontSize('big') }}>大</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }

    return <></>

}

export default ArticleHeader;